let popups = require( './modals' );

var modal_notice = ( function( $ ) {

	var $notice = false;
	var $html   = false;
	var cookie  = 'notice_seen';

	var _init = function() {
		$notice = $( '#notice-modal' );
		$html   = $( 'html' );

		if ( $notice.length > 0 ) {
			_setup();
		}
	};

	var _setup = function() {
		var $reset_timestamp = $notice.attr('data-reset-timestamp');

		if ($reset_timestamp) {
			cookie += $reset_timestamp;
		}

		if ( !already_shown() ) {
			popups.open_modal( $notice );

			$( '.cross-icon' ).on( 'click', function() {
				$.cookie( cookie, 'true', { expires: 5, path: '/' } );
				popups.close_modal( $notice );
			} );
		}
	};

	var already_shown = function() {
		return $.cookie( cookie );
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = modal_notice;